import { useTranslation } from "@opendash/i18n";
import { $parse } from "@opendash/plugin-parse";
import { Form, Select } from "antd";
import { Rule } from "antd/es/form";
import React, { useMemo } from "react";
import ParseQueryForm from "../../ParseQueryForm";
import { Operation } from "../../types/FormValues";
import { Operator } from "../../types/Operations";

type Props = {
  index: number;
  styles: React.CSSProperties;
  rules: Rule[];
  label: string;
};

export default (props: Props) => {
  const t = useTranslation();
  const operations = Form.useWatch("operations");
  const currentOperation: Operation = operations
    ? operations[props.index]
    : undefined;

  // some relation operations need a key to be selected
  const needsKey = operatorNeedsKey(currentOperation?.operator);

  const fields = useMemo(() => {
    if (!currentOperation) return [];
    const targetField = $parse.server.schema.find(
      (s) => s.className === currentOperation?.value?.query?.className
    );
    if (!targetField) return [];
    return Object.keys(targetField.fields).map((key) => ({
      field: key,
      type: targetField.fields[key]?.type?.toLocaleLowerCase(),
      targetClass: targetField.fields[key]?.targetClass,
    }));
  }, [
    currentOperation,
    currentOperation?.field,
    currentOperation?.field?.targetClass,
  ]);

  const valueFieldNameArray = [props.index, "value"];
  if (needsKey) valueFieldNameArray.push("query");

  return (
    <>
      <Form.Item
        label={props.label}
        name={valueFieldNameArray}
        rules={props.rules}
        style={props.styles}
      >
        <ParseQueryForm />
      </Form.Item>
      {needsKey && (
        <Form.Item
          name={[props.index, "value", "key"]}
          label={t("openware:parse.form.value.key.label")}
          rules={props.rules}
          style={props.styles}
        >
          <Select
            options={fields.map((f) => ({
              label: f.field,
              value: f.field,
              type: f.type,
            }))}
          />
        </Form.Item>
      )}
    </>
  );
};

function operatorNeedsKey(operator: Operator) {
  return (
    operator !== "matchesQuery" && operator !== "doesNotMatchQuery" && operator
  );
}
